<template>
  <section class="section-padding">
    <div class="container">
      <slot></slot>
    </div>
  </section>      
</template>